module.exports = __webpack_public_path__ + "img/apple11.77346c29.jpeg";